<template>
    <multiselect class="form-control xinput input-group-sm" v-model.trim="modelo.iddocente" id="id" label="nombre" 
      track-by="id" placeholder="Buscar docente..." open-direction="bottom" 
      :options="datos" :multiple="false" :searchable="true" :loading="isLoading" :internal-search="false" 
      :clear-on-select="true" :close-on-select="true" :options-limit="300" :limit="15" :limit-text="limitText" 
      :max-height="600" :show-no-results="true" :hide-selected="false" :show-labels="false" @search-change="asyncFind">

      <template slot="tag" slot-scope="{ option, remove }"><span class="custom__tag"><span>{{ parseLabel(option) }}</span><span class="custom__remove" @click="remove(option)">❌</span></span></template>
      <template slot="clear" slot-scope="props">
        <div class="multiselect__clear" v-if="modelo.iddocente==null" @mousedown.prevent.stop="clearAll(props.search)"></div>
      </template>
      <span slot="noResult">Docente no encontrado</span>
    </multiselect>
</template>

<script>
import gql from 'graphql-tag'
import {parseJsonError} from '@/components/Utils.js'
export default {
    props:{  
        model:Object, 
        default:{type:Object,required:false,default:null},
        onlyid:{type:Boolean,required:false,default:false}
    },
    data () {
        return {
            isLoading: false,
            datos: [], 
            modelo: {
                iddocente: null,
            }
        }
    }, 
    watch:{
        'modelo.iddocente': function(){
          if( this.modelo.iddocente ) {
              if( this.onlyid ) this.model.iddocente=this.modelo.iddocente.id; 
              else this.model.iddocente=this.modelo.iddocente; 
            }
          else delete this.model.iddocente;
        },
        'default':function(a){
            // window.console.log( "DOCENTE DEFAULTTTTT",a )
            if( a == null ) return;
            this.modelo.iddocente = a;
        },
    },
    methods: {
        parseLabel( option ){
            if( option == null ) return "";
            var seg = option.seg_apellido;
            if( seg == null ) seg = "";
            return option.nombres + " "+option.pri_apellido+" "+seg;
        },
        parseLabel2( option ){
            if( option == null ) return "";
            var seg = option.seg_apellido;
            if( seg == null ) seg = "";
            return option.nombres + " "+option.pri_apellido+" "+seg+" -- Doc: "+option.num_doc;
        },
        limitText (count) {
            return `and ${count} other countries`
        },
        async asyncFind (query) {
            if( query.length <= 3 ) return; 
            this.isLoading = true
            var vue = this;
            var isdocumento = /^\d+$/.test(+query);
            var sql = gql`query{ getPersonasByName(nombres:"${query}"){id,num_doc,nombres,pri_apellido,seg_apellido,domicilio,telefono1,telefono2,contacto } }`;
            if( isdocumento ) sql = gql`query{ getPersonasByDoc(num_doc:"${+query}"){id,num_doc,nombres,pri_apellido,seg_apellido,domicilio,telefono1,telefono2,contacto } }`;
            // window.console.log( "BUSCAR EST",sql ); 
            await this.$apollo.query({
                query: sql,
            }).then((data) => {
                vue.datos = [];
                var datas = [];
                vue.isLoading = false;

                for (var propName in data.data) { 
                    if( propName == "getPersonasByName" || propName == "getPersonasByDoc" ){
                        //window.console.log( "Haber esto",data.data[propName] )
                        if( !data.data[propName] ) break;
                        data.data[propName].forEach( function(e){
                            e.nombre = vue.parseLabel2( e );
                            datas.push( e );
                        });
                    }
                }
                vue.datos = datas;
                window.console.log( data.data,vue.datos )

            }).catch((error) => {
                // window.console.error(error)
                vue.isLoading = false
                this.$notify( parseJsonError( error,'getPersonasByName' ) )
            })
        },
        clearAll () {
            this.modelo.iddocente = null;
        },
    },
    mounted(){
      if( this.default ){
        //this.modelo.iddocente = window.Object({},this.default);
        var e = this.default;
        this.datos.push( {id:e.id,nombre:this.parseLabel2( e )} );
        this.modelo.iddocente = this.datos[0];
      }
    //   window.console.log( "MOUNTED DOCENTE>>>>",this.default );
    }
}
</script>